import { hydrate } from '@tanstack/vue-query';
import createApp from '@/main';
import logger from '@/app/logger';

const { app, queryClient } = createApp();

// Hydrating the Tanstack Query state so that the data queried on the server side
// is available on the client side in the query cache.
if (window.__INITIAL_STATE__) {
  hydrate(queryClient, window.__INITIAL_STATE__);
  logger.info('Hydrating queryClient: queries amount: ' + window.__INITIAL_STATE__.queries?.length);
} else {
  logger.error('No initial state found for hydration');
}

app.mount('#app');
